import { forwardRef } from 'react';
import { Routes, Route } from 'react-router-dom';

import { observer } from 'mobx-react-lite';

import { useGoogleAnalytics } from '@hooks/use-google-analytics';

import Modals from 'components/Modals';
import { useStore } from 'models/stores';

import Job404 from './Job404';
import JobApply from './JobApply';
import JobDetail from './JobDetail';
import JobList from './JobList';
import JobListEnterprise from './JobListEnterprise';

export default observer(
  forwardRef((props, ref) => {
    const { companyStore } = useStore();
    useGoogleAnalytics({
      isReady: Boolean(companyStore?.current),
      trackingId: companyStore?.current?.gaTracker,
    });

    return (
      <div ref={ref} {...props} id="main-content" style={{ position: 'relative' }}>
        <Modals />
        {companyStore.current && (
          <Routes style={{ flexGrow: 1 }}>
            <Route path=":jobID" element={<JobDetail />} />
            <Route path=":jobID/apply" element={<JobApply />} />
            <Route
              path="*"
              element={companyStore.current.isEnterprise ? <JobListEnterprise /> : <JobList />}
            />
            <Route path="/notfound" element={<Job404 />} />
          </Routes>
        )}
      </div>
    );
  }),
);
